import { render, staticRenderFns } from "./AlertRoomAutoLockList.vue?vue&type=template&id=973ee95e&lang=pug&"
import script from "./AlertRoomAutoLockList.vue?vue&type=script&lang=ts&"
export * from "./AlertRoomAutoLockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports